<script>
    import { onMount, tick } from "svelte";

    import { fly } from "svelte/transition";

    import {
        SearchInput,
        SvelteTable,
        PageLoading,
        SearchSelect,
        ResetFilterLink,
    } from "../../Components/Common/index.svelte";
    import TableToggle from "../../Components/Common/TableToggle.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import { providersSpecialityCodes, isMobile } from "../../stores";

    import {
        replaceURL,
        getText,
        getTitle,
        getNumber,
        showError,
        encodeSearchParams,
        decodeSearchParams,
        getBoolean,
    } from "../../Utils/utilFunctions.svelte";

    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";
    import { cacheProviderSpecialityCodes } from "../../Utils/utilCache.svelte";

    export let params = {};

    let isGettingProviders = false,
        returnProvidersArr = [],
        filters = { state: "all" },
        page = 0,
        pageSize = 25,
        count,
        showFilters = false;

    const columns = [
        {
            key: "name",
            title: "Name",
            headerClass:
                "text-left px-3 w-3/12 sortable-header-decoration rounded-tl-xl",
            class: "text-left px-3 cursor-default",
            renderValue: (v) =>
                `${getTitle(v.title)} ${getText(v.firstName)} ${getText(v.lastName)}`,
        },
        {
            key: "specialityCode",
            title: "Speciality Code",
            headerClass: "text-left w-6/12 px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderValue: (v) =>
                `${getNumber(v.specialityCode)} ${
                    v.specialityCodeMame
                        ? "- " + getText(v.specialityCodeMame)
                        : ""
                }`,
        },
        /* {
            key: "isNoGapProgram", 
            title: "is No-Gap Program",
            headerClass: "text-left px-3 w-2/12 cursor-default",
            class: "text-left px-3 w-2/12 cursor-pointer",
            renderComponent: 
            {
                component: TableToggle,
                props: {
                    valueKey: "isNoGapProgram",
                    clickFunction: async (rowData, e) => {
                        e.stopPropagation();
                        console.log(rowData);
                        rowData.isNoGapProgram = !rowData.isNoGapProgram;
                        await apiMethods.putMethod
                            .updateProviderIsGapProgram(rowData.uniqueId, rowData.isNoGapProgram ? 1 : 0)
                            .then((res) => {
                                if (res.error) showError(res.error);
                                else {
                                    //update successfully
                                    loadProviders(
                                        page * pageSize,
                                        pageSize,
                                        _getSearchParams(),
                                    )
                                }
                            });
                    },
                },
            },
            csvContent: (v) => getBoolean(v.isNoGapProgram),
        }, */
        {
            key: "state",
            title: "State",
            headerClass: "text-left px-3 w-1/12 cursor-default rounded-tr-xl",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => getText(v.state).toUpperCase(),
        },
    ];

    const sortableHeaderKeys = ["name"];

    onMount(() => {
        if (params.query) updateSearchParamsByQuery(params.query);

        loadProviders(page * pageSize, pageSize, _getSearchParams());
    });

    const updateSearchParamsByQuery = (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("search="))
                    filters.search = arr[i].split("=")[1].toString();

                if (arr[i].includes("firstName="))
                    filters.firstName = arr[i].split("=")[1].toString();

                if (arr[i].includes("lastName="))
                    filters.lastName = arr[i].split("=")[1].toString();

                if (arr[i].includes("state="))
                    filters.state = arr[i].split("=")[1].toString();

                if (arr[i].includes("sort="))
                    filters.sort = arr[i].split("=")[1].toString();
            }

            updateURL();
        }
    };

    const loadProviders = async (start, limit, params) => {
        isGettingProviders = true;
        if (params.sort) params.sort = params.sort.toLowerCase();

        await cacheProviderSpecialityCodes();

        await tick();

        await apiMethods.getMethod
            .getProviders(start, limit, params)
            .then((res) => _handleProviders(res))
            .then(() => _updateHeaderSortIcon());

        isGettingProviders = false;
    };

    const handleFilterSelect = () => {
        page = 0;

        updateURL();

        loadProviders(0, pageSize, _getSearchParams());
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {};

    const handleClickCol = ({ target: { className } }, rowData, key) => {
        if (sortableHeaderKeys.includes(key)) {
            if (filters.sort == key) filters.sort = `${key}Desc`;
            else filters.sort = key;
            updateURL();
            loadProviders(0, pageSize, _getSearchParams());
        }
    };

    const _updateHeaderSortIcon = () => {
        let thRow = document.getElementsByTagName("th");
        const params = _getSearchParams();

        if (params) {
            setTimeout(() => {
                const upSpan = document.createElement("span");
                const downSpan = document.createElement("span");
                upSpan.innerHTML = `<i class="fas fa-sort-alpha-down" />`;
                upSpan.style = "font-size: 10px;";
                downSpan.innerHTML = `<i class="fas fa-sort-alpha-up-alt" />`;
                downSpan.style = "font-size: 10px;";

                Array.from(thRow).forEach((row) => {
                    if (
                        params.sort == "name" &&
                        row.childNodes[0].data == "Name"
                    )
                        row.appendChild(upSpan);
                    else if (
                        params.sort == "nameDesc" &&
                        row.childNodes[0].data == "Name"
                    )
                        row.appendChild(downSpan);
                });
            }, 0);
        }
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadProviders(
            Number(e.detail.firstDataIndex),
            pageSize,
            _getSearchParams(),
        );
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadProviders(0, newPageSize, _getSearchParams());
    };

    const updateURL = () => {
        replaceURL(
            `/AllProviders/page=${page}&size=${pageSize}${_getParamsString()}`,
        );
    };

    // HELPER FUNCTIONS
    const _handleProviders = async (res, isCsvContent = false) => {
        if (res.error) showError(res.error);
        else {
            const resArr = [];
            count = res.total;

            res.results.map((result) => {
                resArr.push({
                    ...result,
                    specialityCodeMame: $providersSpecialityCodes.some(
                        (code) => code.id == result.specialityCode,
                    )
                        ? $providersSpecialityCodes.filter(
                              (code) => code.id == result.specialityCode,
                          )[0].name
                        : "",
                });
            });

            if (isCsvContent) return resArr;
            else returnProvidersArr = [...resArr];
        }
    };

    const _getSearchParams = () => {
        let params = {};

        if (filters.sort) params.sort = filters.sort;

        if (filters.search) params.search = filters.search;

        if (filters.firstName) params["filter[firstName]"] = filters.firstName;

        if (filters.lastName) params["filter[lastName]"] = filters.lastName;

        if (filters.state && filters.state !== "all")
            params["filter[state]"] = filters.state;

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.search) str += `&search=${params.search}`;

            if (params["filter[firstName]"])
                str += `&firstName=${params["filter[firstName]"]}`;

            if (params["filter[lastName]"])
                str += `&lastName=${params["filter[lastName]"]}`;

            if (params["filter[state]"])
                str += `&state=${params["filter[state]"]}`;
        }

        return encodeSearchParams(str);
    };

    const toggleFilters = () => {
        showFilters = !showFilters;
    };

    const filterTransition = (node, args) => ($isMobile ? fly(node, args) : "");
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if $isMobile}
        <button
            class="btn btn-accent btn-sm w-28 flex flex-row gap-x-3"
            on:click={toggleFilters}
        >
            Filters
            <i
                style="font-size:20px"
                class={showFilters ? "fa arrow-up" : "fa arrow-down"}
                >&#xf104;
            </i>
        </button>

        {#if showFilters}
            <div
                class="flex w-full flex-wrap flex-row gap-4 items-end"
                in:filterTransition={{ duration: 200, y: -100 }}
            >
                <SearchInput
                    bind:value={filters.search}
                    title="Search"
                    inputFunc={handleFilterSelect}
                    isLong
                />
                <SearchSelect
                    title="State"
                    bind:value={filters.state}
                    onChangeFunc={handleFilterSelect}
                    isLong
                >
                    <option value="all">All</option>
                    <option value="VIC">Victoria</option>
                    <option value="NSW">New South Wales</option>
                    <option value="QLD">Queensland</option>
                    <option value="TAS">Tasmania</option>
                    <option value="WA">Western Australia</option>
                    <option value="SA">South Australia</option>
                    <option value="NT">Northern Territory</option>
                    <option value="ACT">Australian Capital Territory</option>
                </SearchSelect>

                <SearchInput
                    bind:value={filters.firstName}
                    title="First name"
                    inputFunc={handleFilterSelect}
                    isLong
                />

                <SearchInput
                    bind:value={filters.lastName}
                    title="Last name"
                    inputFunc={handleFilterSelect}
                    isLong
                />

                <ResetFilterLink
                    bind:filter={filters}
                    onResetFilter={handleFilterSelect}
                />
            </div>
        {/if}
    {:else}
        <div
            class="flex flex-0 flex-row gap-4 items-end justify-start"
            in:filterTransition={{ duration: 200, y: -100 }}
        >
            <SearchInput
                bind:value={filters.search}
                title="Search"
                inputFunc={handleFilterSelect}
                isLong
            />
            <SearchSelect
                title="State"
                bind:value={filters.state}
                onChangeFunc={handleFilterSelect}
                isLong
            >
                <option value="all">All</option>
                <option value="VIC">Victoria</option>
                <option value="NSW">New South Wales</option>
                <option value="QLD">Queensland</option>
                <option value="TAS">Tasmania</option>
                <option value="WA">Western Australia</option>
                <option value="SA">South Australia</option>
                <option value="NT">Northern Territory</option>
                <option value="ACT">Australian Capital Territory</option>
            </SearchSelect>

            <SearchInput
                bind:value={filters.firstName}
                title="First name"
                inputFunc={handleFilterSelect}
                isLong
            />

            <SearchInput
                bind:value={filters.lastName}
                title="Last name"
                inputFunc={handleFilterSelect}
                isLong
            />

            <ResetFilterLink
                bind:filter={filters}
                onResetFilter={handleFilterSelect}
            />
        </div>
    {/if}

    <div class={$isMobile ? "h-auto w-minus48" : "relative flex-1"}>
        {#if isGettingProviders}
            <PageLoading />
        {:else}
            <div
                class={$isMobile
                    ? "overflow-x-auto overflow-y-visible"
                    : "overflow-y-auto absolute inset-0"}
            >
                <SvelteTable
                    {columns}
                    rows={returnProvidersArr}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                    customRow="align-middle"
                />
            </div>
        {/if}
    </div>

    <TableFooter
        {page}
        {pageSize}
        {count}
        tableData={returnProvidersArr}
        {onPageChange}
        {onPageSizeChange}
        csvConfig={{
            columns,
            data: returnProvidersArr,
            fileName: "Providers",
            allDataApi: async () => {
                let res = await apiMethods.getMethod.getProviders(
                    0,
                    999999,
                    _getSearchParams(),
                );

                const results = await _handleProviders(res, true);

                return { results };
            },
        }}
    />
</div>
